<h2 class="text-center"> Country Information <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span></h2>
<p class="text-center">
    <a [routerLink]="['/admin/countries/edit',0]">Add New Country</a>
</p>
<div class="table-responsive" *ngIf="countryList">
  <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
    <thead>
    <tr>
    <td>Name</td>
    <th>Alpha2</th>
    <th>Currency Code</th>
    <th>Currency Abbreviation</th>
    <th>Syllabus</th>
    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let countryItem of countryList;">
        <td>
          <a [routerLink]="['/admin/countries/show/',countryItem['id']]">
            {{countryItem['name']}}
           </a>
        </td>
        <td>{{countryItem['alpha2']}}</td>
        <td>{{countryItem['currencyCode']}}</td>
        <td>{{countryItem['currencyAbbreviation']}}</td>
        <td>
          <a  *ngIf="countryItem['server_education_system_id']!=0" [routerLink]="">
            {{countryItem['educationSystem']}}
          </a>
          <span *ngIf="countryItem['server_education_system_id']==0"></span>
        </td>
    </tr>
    </tbody>

</table>

</div>
<div *ngIf="countryList && !loading" class="text-center">
  <div *ngIf="countryList.length==0" class="text-center">
    No Countries found
  </div>
</div>


